import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { AdminQuestionsComponent } from '../admin-questions/admin-questions.component';

@Component({
  selector: 'app-add-individual-question',
  templateUrl: './add-individual-question.component.html',
  styleUrls: ['./add-individual-question.component.scss']
})
export class AddIndividualQuestionComponent implements OnInit {
  options = ['1', '2'];
  DataStructure="";
  question = new FormControl(null, [Validators.required,this.noWhitespaceValidator]);
  noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }
  constructor(private dialogRef: MatDialogRef<AdminQuestionsComponent>){
    dialogRef.disableClose = true;
  }
  ngOnInit() {
  }
  getErrorForQuestion() {
    return this.question.hasError('required') ? 'Question can\'t be blank' :
    this.question.hasError('whitespace') ? 'Please provide valid question': 
    '';
  }
  selectionChangeForSingleMultiple(event) {
    console.log(event)
  }

  addOption() {
    if(this.options.length < 5) {
    this.options.push('3');
    }
  }
  removeOption(index) {
    if(this.options.length > 2)
    this.options.splice(index, 1);
  }
}
